import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { PermissionsService } from '../services/auth/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class FunctionalPermissionGuard {
  private router = inject(Router);
  private permissionsService = inject(PermissionsService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredFunctionalPermission = route.data['requiredFunctionalPermission'];
    const redirectURL = route.data['redirectUrl'];

    if (requiredFunctionalPermission.length == 0) return true;

    return this.permissionsService.user_has_FunctionalPermission(requiredFunctionalPermission).pipe(
      map((result) => {
        if (result == false) {
          this.router.navigate([redirectURL]);
        }
        return result;
      }),
    );
  }
}
